<template>
  <div class="core">
    <div class="layui-layer-title" style="cursor: move;"></div>
    <div class="layui-layer-content">
      <div class="layui-layer-wrap">
        <div class="form-collapse">
          <div class="info">
            <layui-form ref="brandForm"  :after-save='handleAfterSave' :rule="service_form_rule" :requestUniqueId="requestId">
              <template slot-scope="{ scope }">
                <div class="layui-form">
                  <template>
                    <layui-collapse>
                      <div class="layui-colla-item">
                        <h2 class="layui-colla-title">品牌基本信息</h2>
                        <div class="layui-colla-content layui-show">
                          <div class="layui-form-item-one">
                            <div class="layui-form-item" v-if="formType == 'edit' || formType === 'browser'">
                              <label class="layui-form-label">品牌编号： </label>
                              <div class="layui-input-inline" style="width: 30%;">
                                <input
                                  type="text"
                                  :disabled="true"
                                  v-model="config.form.BRAND_BH"
                                  autocomplete="off"
                                  class="layui-input layui-disabled"
                                  name="BRAND_BH"
                                  placeholder="请输入品牌编号"
                                />
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label"> <span class="x-red">*</span>品牌名称： </label>
                              <div class="layui-input-inline" style="width: 30%;">
                                <input
                                  type="text"
                                  :disabled="isBrowserStatus"
                                  v-model="config.form.BRAND_NAME"
                                  autocomplete="off"
                                  :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'"
                                  name="BRAND_NAME"
                                  placeholder="请输入品牌名称"
                                />
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label"><span class="x-red">*</span>项目经理： </label>
                              <div class="layui-input-inline" style="width: 30%;">
                                <layui-multiselect
                                  :single="true"
                                  :enabled="!isBrowserStatus"
                                  name="MANAGER_ID"
                                  table-name="YW_MANAGER"
                                  text-field="MANAGER_NAME"
                                  value-field="MANAGER_ID"
                                  :show-null-option="true"
                                  :enable-search="true"
                                  v-model="config.form.MANAGER_ID"
                                ></layui-multiselect>
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label"><span class="x-red">*</span>客户名称： </label>
                              <div class="layui-input-inline" style="width: 30%;">
                                <layui-multiselect
                                  :single="true"
                                  :enabled="!isBrowserStatus"
                                  name="CLIENT_ID"
                                  table-name="YW_CUSTOMER_CLIENT"
                                  text-field="CLIENT_NAME"
                                  value-field="CLIENT_ID"
                                  :show-null-option="true"
                                  :enable-search="true"
                                  v-model="config.form.CLIENT_ID"
                                ></layui-multiselect>
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label"><span class="x-red">*</span>结算类型： </label>
                              <div class="layui-input-inline" style="width: 30%;">
                                <layui-multiselect
                                  :single="true"
                                  :enabled="!isBrowserStatus"
                                  name="BALANCE_TYPE"
                                  table-name="DB_DICTIONARY"
                                  text-field="DIC_NAME"
                                  id-field="ID"
                                  parent-field="DIC_PCODE"
                                  value-field="DIC_CODE"
                                  :show-null-option="true"
                                  :queryCondition="{ DIC_CATEGORY: '结算类型', 'JB:5': '2' }"
                                  :enable-search="true"
                                  v-model="config.form.BALANCE_TYPE"
                                ></layui-multiselect>
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">结算周期： </label>
                              <div class="layui-input-inline" style="width: 30%;">
                                <layui-daterange
                                  v-if="!isBrowserStatus"
                                  class="dateRange"
                                  name="TIME_RANGE"
                                  v-model="config.form.TIME_RANGE"
                                  @dateChange="handleDateChange($event)"
                                ></layui-daterange>
                                <input
                                  v-else
                                  type="text"
                                  :disabled="isBrowserStatus"
                                  v-model="config.form.TIME_RANGE"
                                  autocomplete="off"
                                  :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'"
                                  name="TIME_RANGE"
                                />
                              </div>
                            </div>
                            <div class="layui-form-item" v-for="(val, ind) in rulesForms.form" :key="ind">
                              <label class="layui-form-label"><span class="x-red">*</span>SLA等级： </label>
                              <div class="layui-input-inline" style="width: 12%;">
                                <layui-multiselect
                                  :single="true"
                                  :enabled="!isBrowserStatus"
                                  table-name="DB_DICTIONARY"
                                  text-field="DIC_NAME"
                                  id-field="ID"
                                  parent-field="DIC_PCODE"
                                  value-field="DIC_NAME"
                                  :show-null-option="true"
                                  :queryCondition="{ DIC_CATEGORY: 'SLA等级', 'JB:5': '2' }"
                                  :enable-search="true"
                                  v-model="val.SLA_LEVEL"
                                ></layui-multiselect>
                              </div>
                              <div class="layui-input-inline" style="width: 12%;">
                                <input
                                  type="number"
                                  :disabled="isBrowserStatus"
                                  min="0"
                                  v-model="val.SLA_HOUR"
                                  autocomplete="off"
                                  :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'"
                                  name="SLA_HOUR"
                                  placeholder="请输入小时"
                                />
                              </div>
                              <span style="height: 32px;line-height: 32px;">单位：小时</span>
                              <span
                                v-if="!isBrowserStatus"
                                class="project-inner-add"
                                @click="addBrand()"
                                style="cursor: pointer;margin-left:12px"
                              >
                                <i class="layui-icon layui-icon-add-circle" style="color:#00A0E9 "></i>
                                新增
                              </span>
                              <span
                                v-if="!isBrowserStatus"
                                class="project-inner-add"
                                @click="delBrand(ind)"
                                style="cursor: pointer;margin-left:12px"
                              >
                                <i class="layui-icon layui-icon-add-circle" style="color:#00A0E9 "></i>
                                删除
                              </span>
                            </div>

                            <div class="layui-form-item">
                              <label class="layui-form-label">超时时间(h)：</label>
                              <div class="layui-input-inline">
                                <el-input-number
                                  style="width: 88%"
                                  v-model="over_time_hour"
                                  @change="handleChange"
                                  :min="1"
                                  :max="48"
                                  size="small"
                                  label="描述文字"
                                ></el-input-number>
                              </div>
                            </div>

                            <div class="layui-form-item">
                              <label class="layui-form-label">描述： </label>
                              <div class="layui-input-inline" style="width: 30%;">
                                <textarea
                                  :disabled="isBrowserStatus"
                                  v-model="config.form.BRAND_DESCRIBE"
                                  autocomplete="off"
                                  :class="isBrowserStatus ? 'layui-textarea layui-disabled' : 'layui-textarea'"
                                  name="BRAND_DESCRIBE"
                                  placeholder="请输入描述"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </layui-collapse>
                  </template>
                </div>
                <div class="layui-form-btn">
                  <div class="layui-footer">
                    <button class="layui-btn refresh" title="关闭" @click="handleBtnclick('close')">
                      关 闭
                    </button>
                    <button v-if="!isBrowserStatus" class="layui-btn" title="保存" @click="handleBtnclick('save')">
                      保 存
                    </button>
                  </div>
                </div>
              </template>
            </layui-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    formType: {
      type: String,
      default: () => ''
    },
    formData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      requestId: 'CustomerBrandRequest',
      service_form_rule: {
        BRAND_NAME: {
          required: { message: '品牌名称不能为空' }
        },
        MANAGER_ID: {
          required: { message: '项目经理不能为空' }
        },
        CLIENT_ID: {
          required: { message: '客户名称不能为空' }
        },
        BALANCE_TYPE: {
          required: { message: '结算类型不能为空' }
        }
        // SLA_LEVEL: {
        //   required: { message: 'SLA等级不能为空'},
        // },
        // SLA_HOUR: {
        //   required: { message: '时长不能为空'},
        // }
      },
      config: {
        form: {}
      },
      rulesForms: {
        form: [
          {
            SLA_LEVEL: '',
            SLA_HOUR: ''
          }
        ]
      },
      isBrowserStatus: false,
      over_time_hour: 24
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.formType === 'edit') {
        this.rulesForms.form = []
        this.$refs.brandForm.openWin('编辑品牌', this.close_callBack)
        //赋值结算周期
        if (this.formData.BALANCE_START_DATE && this.formData.BALANCE_END_DATE) {
          this.formData.TIME_RANGE = this.formData.BALANCE_START_DATE + ' - ' + this.formData.BALANCE_END_DATE
        }
        if (this.formData.SLA_CLUB) {
          let formdata = this.formData.SLA_CLUB.split(',')
          formdata.forEach((item, ind) => {
            let _obj = {},
              sla_hour = item.split('(')[1]
            _obj.SLA_LEVEL = item.split('(')[0]
            _obj.SLA_HOUR = sla_hour.slice(0, sla_hour.length - 1)
            this.rulesForms.form.push(_obj)
          })
        } else {
          this.rulesForms = {
            form: [{ SLA_LEVEL: '', SLA_HOUR: '' }]
          }
        }
        this.config.form = this.formData
      } else if (this.formType === 'browser') {
        this.rulesForms.form = []
        this.$refs.brandForm.openWin('编辑品牌', this.close_callBack)
        //赋值结算周期
        if (this.formData.BALANCE_START_DATE && this.formData.BALANCE_END_DATE) {
          this.formData.TIME_RANGE = this.formData.BALANCE_START_DATE + ' - ' + this.formData.BALANCE_END_DATE
        }
        if (this.formData.SLA_CLUB) {
          let formdata = this.formData.SLA_CLUB.split(',')
          formdata.forEach((item, ind) => {
            let _obj = {},
              sla_hour = item.split('(')[1]
            _obj.SLA_LEVEL = item.split('(')[0]
            _obj.SLA_HOUR = sla_hour.slice(0, sla_hour.length - 1)
            this.rulesForms.form.push(_obj)
          })
        } else {
          this.rulesForms = {
            form: [{ SLA_LEVEL: '', SLA_HOUR: '' }]
          }
        }
        this.config.form = this.formData
        this.isBrowserStatus = true
      } else {
        this.$refs.brandForm.openWin('新增品牌', this.close_callBack)
      }
    })
  },
  methods: {
    /**
     * form弹窗关闭的回调
     */
    close_callBack() {
      this.$emit('update:visible', false)
    },
    addBrand() {
      this.rulesForms.form.push({
        SLA_LEVEL: '',
        SLA_HOUR: ''
      })
    },
    handleChange(value) {
      this.over_time_hour = value
    },
    delBrand(ind) {
      if (this.rulesForms.form.length <= 1) {
        this.layer.openAlert('请至少添加一个SLA等级!')
        return
      } else {
        this.rulesForms.form.splice(ind, 1)
      }
    },
    /**
     * 保存、重置
     */
    handleBtnclick(type) {
      switch (type) {
        case 'close': {
          if (this.tabParam) {
            this.baseComponent.closeComponent(this.tabParam.cloneMenu)
            if (this.tabParam.from == 'storeForm') {
              this.baseComponent.currentComponent = this.tabParam.sourceMenu
            } else {
              this.$emit('update:visible', false)
            }
          } else {
            this.$emit('update:visible', false)
          }
          break
        }
        case 'save': {
          this.handelSlaClub()
          this.config.form.OVER_TIME_HOUR = this.over_time_hour
          this.$refs.brandForm.editRow = this.config.form
          let flag = this.rulesForms.form.some(element => {
            return element.SLA_LEVEL === '' || element.SLA_HOUR === ''
          })
          if (!flag) {
            console.log(this.$parent.$refs.brand);
            console.log(this.$parent.$refs.brand);
            if (this.$parent.$refs.brand) {
              this.$refs.brandForm.save(this.$parent.$refs.brand)
            } else {
              this.$refs.brandForm.callableSave('yw_customer_brand')
            }
          } else {
            this.layer.openAlert('SLA等级或者时长不能为空!')
          }

          break
        }
        default: {
          break
        }
      }
    },
    handleAfterSave() {
      this.baseComponent.closeComponent(this.tabParam.cloneMenu)

      if (this.tabParam.from === 'storeForm') {
        this.baseComponent.currentComponent = this.tabParam.sourceMenu;
      } else {
        this.baseComponent.loadComponentByName('storeManagerManage')
        if (this.tableObj) {
          this.tableObj.pageInfo.pageIndex = 1
          this.tableObj.load()
        }
      }
    },
    handelSlaClub() {
      let content = ''
      if (this.rulesForms.form && this.rulesForms.form.length) {
        let data = this.rulesForms.form
        data.forEach(element => {
          content += element.SLA_LEVEL + '(' + element.SLA_HOUR + ')' + ','
        })
        content = content.slice(0, content.length - 1)
      }
      this.config.form.SLA_CLUB = content
    },
    handleDateChange(daterange) {
      var range = daterange.split(' - ')
      var startTime = range[0]
      var endTime = range[1]
      this.config.form.BALANCE_START_DATE = startTime
      this.config.form.BALANCE_END_DATE = endTime
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/person/brandManage/brandForm.vue